var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVanMoving({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.6,193.9l-33.5-22.1L376,79c-2.8-3.6-7.2-5.7-11.8-5.7H57.3C25.7,73.3,0,99,0,130.6v205.1c0,23.6,16,43.5,37.8,49.4 c6,30.5,32.9,53.7,65.2,53.7c31.6,0,58.1-22.2,64.8-51.8h147.9c6.7,29.6,33.2,51.8,64.8,51.8s58.1-22.2,64.8-51.8h15.5 c28.3,0,51.3-23,51.3-51.3v-91.3C512,223.5,500.8,204.2,482.6,193.9L482.6,193.9z M412,173.2H291.9v-69.9h65L412,173.2z  M102.9,408.8c-20.1,0-36.4-16.3-36.4-36.4c0-20.1,16.3-36.4,36.4-36.4s36.4,16.3,36.4,36.4C139.4,392.4,123,408.8,102.9,408.8z  M102.9,305.9c-30,0-55.4,20-63.6,47.3c-5.6-3.8-9.3-10.3-9.3-17.6v-58h26.2c8.3,0,15-6.7,15-15s-6.7-15-15-15H30V130.6 c0-15.1,12.3-27.3,27.3-27.3h204.6v253.7h-94.4C160.6,327.7,134.3,305.9,102.9,305.9L102.9,305.9z M380.5,408.8 c-20.1,0-36.4-16.3-36.4-36.4c0-20.1,16.3-36.4,36.4-36.4s36.4,16.3,36.4,36.4C416.9,392.4,400.5,408.8,380.5,408.8z M460.7,356.9 h-15.7c-7-29.2-33.3-51-64.6-51s-57.6,21.8-64.6,51h-23.9V203.2h150.3l24.3,16.1c0.3,0.2,0.7,0.4,1,0.6c8.9,4.9,14.4,14.3,14.4,24.5 v3.3h-30c-8.3,0-15,6.7-15,15s6.7,15,15,15h30v58C482,347.4,472.5,356.9,460.7,356.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanMoving);
export default __webpack_public_path__ + "static/media/van-moving.1cc6055b27a7ca05a584ee75ffbda4eb.svg";
export { ForwardRef as ReactComponent };